import { RawTooltip } from 'ui/tooltip'

import {
  GemTemplateTooltip,
  GemTooltip,
  ItemTemplateTooltip,
  ItemTooltip
} from './ItemTooltip'
import {
  PassiveNodeTooltip,
  PassiveSkillTooltip,
  TattooTooltip
} from './PassiveTooltip'

import { Gem, Item, ItemTooltipOptions } from '@/types/item'
import './tooltip.scss'

export {
  GemTooltip,
  ItemTemplateTooltip,
  ItemTooltip,
  PassiveNodeTooltip,
  PassiveSkillTooltip
}

type RawTooltipProps = Omit<Parameters<typeof RawTooltip>[0], 'tooltip'>

export function WithItemTooltip({
  item,
  options,
  ...props
}: {
  item: Item
  options?: ItemTooltipOptions
} & RawTooltipProps) {
  return (
    <RawTooltip
      tooltip={<ItemTooltip item={item} options={options} />}
      {...props}
    />
  )
}

export function WithItemTemplateTooltip({
  name,
  variant,
  ...props
}: {
  name: string
  variant?: number
} & RawTooltipProps) {
  return (
    <RawTooltip
      tooltip={<ItemTemplateTooltip name={name} variant={variant} />}
      {...props}
    />
  )
}

export function WithGemTooltip({
  gem,
  ...props
}: {
  gem: Gem
} & RawTooltipProps) {
  return <RawTooltip tooltip={<GemTooltip gem={gem} />} {...props} />
}

export function WithGemTemplateTooltip({
  id,
  ...props
}: {
  id: string
} & RawTooltipProps) {
  return <RawTooltip tooltip={<GemTemplateTooltip id={id} />} {...props} />
}

export function WithPassiveTooltip({
  version,
  id,
  masteryIndex,
  atlas,
  onSelect,
  ...props
}: Parameters<typeof PassiveNodeTooltip>[0] & RawTooltipProps) {
  return (
    <RawTooltip
      tooltip={
        <PassiveNodeTooltip
          version={version}
          id={id}
          masteryIndex={masteryIndex}
          atlas={atlas}
          onSelect={onSelect}
        />
      }
      {...props}
    />
  )
}

export function WithPassiveSkillTooltip({
  skill,
  masteryIndex,
  atlas,
  onSelect,
  ...props
}: Parameters<typeof PassiveSkillTooltip>[0] & RawTooltipProps) {
  return (
    <RawTooltip
      tooltip={
        <PassiveSkillTooltip
          skill={skill}
          masteryIndex={masteryIndex}
          atlas={atlas}
          onSelect={onSelect}
        />
      }
      {...props}
    />
  )
}

export function WithTattooTooltip({
  id,
  ...props
}: {
  id: string
} & RawTooltipProps) {
  return <RawTooltip tooltip={<TattooTooltip id={id} />} {...props} />
}
